export default __webpack_public_path__ + "static/media/icon_topic_cloud_chart.8d332735.svg";